import { render, staticRenderFns } from "./ProsAndConsTab.vue?vue&type=template&id=27d8c32a&"
import script from "./ProsAndConsTab.vue?vue&type=script&lang=js&"
export * from "./ProsAndConsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports